import React, { useState } from "react";
import { OverlayTrigger, Tooltip, Form, Modal, Button } from "react-bootstrap";

/**
 * BlockedProductCard
 * Read-only version of ProductCard for the Blocked Products tab.
 *
 * Design (QA approved):
 * - Stock invalid        → "N/A" (not "—")
 * - Transfer Price null  → "N/A" (not "—")
 * - Reason column:
 *     "Blocked: Please contact seller support"  ← black text
 *     [🔴?] Need Help?                          ← red circle button (white ?) + red "Need Help?" text
 *     Hover on "Need Help?" shows actual blockedReason as tooltip
 *     Click anywhere on the Need Help area opens the help modal
 */
function BlockedProductCard(props) {
  const [selectedCombinationIndex, setSelectedCombinationIndex] = useState(0);
  const [showHelpModal, setShowHelpModal] = useState(false);

  const [expanded, setExpanded] = useState(false);
  // ─── Combination dropdown (view only) ────────────────────────────────────
  const handleCombinationChange = (e) => {
    const parts = e.value.split(",");
    const newIndex = parseInt(parts[1]);
    setSelectedCombinationIndex(newIndex);
  };

  // ─── Stock display ────────────────────────────────────────────────────────
  const renderStockSection = () => {
    const stockValue =
      props.combination && props.combination.length > 0
        ? props.combination[selectedCombinationIndex]?.stock
        : props.quantity;

    const hasValidStock =
      stockValue !== undefined &&
      stockValue !== null &&
      stockValue !== "" &&
      stockValue >= 0;

    return (
      <span
        style={{
          fontSize: "14px",
          fontWeight: "500",
          color: hasValidStock ? (stockValue === 0 ? "red" : "#000") : "#aaa",
        }}
      >
        {hasValidStock ? stockValue : "N/A"}
      </span>
    );
  };

  // ─── Transfer Price display ───────────────────────────────────────────────
  const renderPrice = (price) => {
    if (!price) {
      return <span style={{ color: "#aaa" }}>N/A</span>;
    }
    return (
      <div className="prod-price">
        <i className="fa fa-inr" aria-hidden="true"></i> {parseInt(price)}
        {props.taxClass &&
          props.taxClass !== null &&
          props.taxClass !== "undefined" &&
          !isNaN(props.taxClass) && (
            <span className="prod-card-gst"> (incl. {props.taxClass}% GST)</span>
          )}
      </div>
    );
  };

  // ─── Blocked reason section ───────────────────────────────────────────────
  
const renderBlockedReason = () => {

  const tooltipText =
    props.blockedReason ||
    props.vendor?.reason ||
    "No reason provided";

  const isLong = tooltipText.length > 100;
  const displayText = expanded
    ? tooltipText
    : tooltipText.slice(0, 100) + (isLong ? "..." : "");

  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "4px" }}>
      {/* Line 1 */}
      
        <span
          onClick={() => setExpanded(!expanded)}
          style={{
            color: "#212529",
            fontSize: "13px",
            fontWeight: "500",
            lineHeight: "1.4",
            cursor: isLong ? "pointer" : "default",
          }}
        >
          {displayText}
          {isLong && (
            <span style={{ color: "#0d6efd", marginLeft: "5px" }}>
              {expanded ? "Read Less" : "Read More"}
            </span>
          )}
           
        </span>
<OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id={`blocked-reason-tooltip-${props.id}`}>
            Need Help?
          </Tooltip>
        }
      >
        <div
          onClick={() => setShowHelpModal(true)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "5px",
            cursor: "pointer",
            width: "fit-content",
          }}
        >
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              backgroundColor: "#dc3545",
              color: "#fff",
              fontSize: "12px",
              fontWeight: "700",
              flexShrink: 0,
              lineHeight: 1,
            }}
          >
            ?
          </span>
        </div>
      </OverlayTrigger>
      {/* Line 2 */}
     
    </div>
  );
};



  // ─── Help Modal ───────────────────────────────────────────────────────────
  const renderHelpModal = () => (
    <Modal show={showHelpModal} onHide={() => setShowHelpModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Get Help</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
          Help with: <strong>{props.productName}</strong>
        </p>

        <div className="help-options">
          <div className="help-option mb-3 p-3 border rounded">
            <h6 className="mb-2">
              <i className="bi bi-envelope me-2"></i>
              Email Support
            </h6>
            <a
              href="mailto:sellersupport@toolsvilla.com"
              className="btn btn-outline-primary btn-sm"
            >
              <i className="bi bi-envelope me-2"></i>
              sellersupport@toolsvilla.com
            </a>
          </div>

          <div className="help-option p-3 border rounded">
            <h6 className="mb-2">
              <i className="bi bi-ticket-perforated me-2"></i>
              Raise a Ticket
            </h6>
            <p className="mb-2 text-muted" style={{ fontSize: "13px" }}>
              Get support from our team
            </p>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShowHelpModal(false);
                window.location.href = "/seller-support";
              }}
            >
              <i className="bi bi-ticket-perforated me-2"></i>
              Raise a Ticket
            </Button>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={() => setShowHelpModal(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );

  // ─── Combination product ──────────────────────────────────────────────────
  if (props.combination && props.combination.length > 0) {
    const selectedComb = props.combination[selectedCombinationIndex];

    return (
      <>
        <tr className="space color-row5 ord_table_row">
          {/* Product */}
          <td className="fs-13 invent_table_pname_cntn">
            <div className="invent_table_first_col">
              <div>
                <img
                  src={"https://s3.toolsvilla.com/" + props.image}
                  alt="img"
                  className="px-2 invent_table_pro_img mx-1"
                />
              </div>
              <div className="inline-initial">
                <span className="prod-name" style={{ color: "#333", fontWeight: 500 }}>
                  {props.productName}
                </span>
                <p className="order_table_sku">SKU:- {props.SKU}
                  <a href="#"  onClick={props.onDetailClick} class="detail-but"><button class="px-1 order_table_btn_details"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-3.5 h-3.5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg> Details</button></a></p>
                <p className="invent_table_sku my-2">
                  Combination's added:{" "}
                  <Form.Select
                    size="sm"
                    className="pro_card_comb_box_invent"
                    value={`${props.id},${selectedCombinationIndex}`}
                    onChange={(e) => handleCombinationChange(e.target)}
                  >
                    {props.combination.map((item, index) => (
                      <option key={index} value={`${props.id},${index}`}>
                        {item.com}
                      </option>
                    ))}
                  </Form.Select>
                </p>
              </div>
            </div>
          </td>

          {/* Stock */}
          <td>
            <div className="border-x">{renderStockSection()}</div>
          </td>

          {/* Transfer Price */}
          <td>
            <div className="border-x">{renderPrice(selectedComb?.price)}</div>
          </td>

          {/* Reason */}
          <td>
            <div className="border-x">{renderBlockedReason()}</div>
          </td>
        </tr>

        {renderHelpModal()}
      </>
    );
  }

  // ─── Simple (non-combination) product ─────────────────────────────────────
  return (
    <>
      <tr className="space color-row5 ord_table_row">
        {/* Product */}
        <td className="fs-13 invent_table_pname_cntn">
          <div className="invent_table_first_col">
            <div>
              <img
                src={"https://s3.toolsvilla.com/" + props.image}
                alt="img"
                className="px-2 invent_table_pro_img mx-1"
              />
            </div>
            <div className="inline-initial">
              <span className="prod-name" style={{ color: "#333", fontWeight: 500 }}>
                {props.productName}
              </span>
              

               {/* ── add this ── */}
                  {/*props.onDetailClick && (
                    <span
                      onClick={props.onDetailClick}
                      style={{
                        fontSize: "12px",
                        color: "#0d6efd",
                        cursor: "pointer",
                        display: "block",
                        marginTop: "2px",
                      }}
                    >
                      <i className="bi bi-eye me-1"></i>View Details
                    </span>
                  )*/}
              <p className="order_table_sku">SKU:- {props.SKU}
              <a href="#"  onClick={props.onDetailClick} class="detail-but"><button class="px-1 order_table_btn_details"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-3.5 h-3.5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg> Details</button></a></p>
            </div>
          </div>
        </td>

        {/* Stock */}
        <td>
          <div className="border-x">{renderStockSection()}</div>
        </td>

        {/* Transfer Price */}
        <td>
          <div className="border-x">{renderPrice(props.price)}</div>
        </td>

        {/* Reason */}
        <td>
          <div className="border-x">{renderBlockedReason()}</div>
        </td>
      </tr>

      {renderHelpModal()}
    </>
  );
}

export default BlockedProductCard;